import React from 'react';
export const Plus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 11.1V12.9H12.9V19.5H11.1V12.9H4.5V11.1H11.1V4.5H12.9V11.1H19.5Z"
        fill="white"
      />
    </svg>
  );
};
